// extracted by mini-css-extract-plugin
module.exports = {"w1vvzd3i":"w1vvzd3i"};